import React from "react";
import { utils } from "@/utils";
import type { categoryTwoItem } from "@/types/product";

import styles from "./ExpandPanelModal.module.less";

interface ExpandPanelModalProps {
  expandPanelSelectedIndex: number;
  onToggleShowExpandPanelModal: () => void;
  expandPanelData: categoryTwoItem[];
  onExpandPanelChange: (index: number) => void;
}

const { capitalizeFirstLetter } = utils;

const ExpandPaneModal: React.FC<ExpandPanelModalProps> = (props) => {
  const {
    onToggleShowExpandPanelModal,
    expandPanelData,
    onExpandPanelChange,
    expandPanelSelectedIndex,
  } = props;

  const Item = () => {
    return expandPanelData.map((item: categoryTwoItem, index: number) => {
      const classNames = `${styles["expand-panel-item"]} ep ${
        index === expandPanelSelectedIndex ? styles["selected"] : ""
      }`;

      return (
        <div
          className={classNames}
          key={item.categoryId}
          onClick={() => onExpandPanelChange(index)}
        >
          {capitalizeFirstLetter(item.categoryName)}
        </div>
      );
    });
  };

  return (
    <div className={styles["expand-panel-modal"]} onClick={onToggleShowExpandPanelModal}>
      <div className={styles["expand-panel-container"]}>
        <div className={styles["expand-panel-flex"]}>
          <Item />
        </div>
      </div>
    </div>
  );
};

export default ExpandPaneModal;
